import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bowler-profile-summary" }
const _hoisted_2 = { class: "bowler-profile-summary-data" }

import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'BowlerProfileSummary',
  setup(__props) {

const bowler = useBowlerStore()

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FontAwesomeIcon, {
        class: "icon",
        icon: "bowling-ball"
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(formatValue)(_unref(bowler).activeMembership?.clubName)), 1),
      _createVNode(_component_FontAwesomeIcon, {
        class: "icon icon-mirrored",
        icon: "bowling-ball"
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(formatValue)(_unref(bowler).activeMembership?.associationName)), 1),
      _createVNode(_component_FontAwesomeIcon, {
        class: "icon",
        icon: "envelope"
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(formatValue)(_unref(bowler).email)), 1),
      _createVNode(_component_FontAwesomeIcon, {
        class: "icon",
        icon: "phone"
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(formatValue)(_unref(bowler).phoneNumber)), 1)
    ]),
    _createVNode(RouterLinkButton, { to: { path: '/profile' } }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('nav.profile')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})